/**
 * Checks if a given Enum type contains the value
 * @param enumType the enum type
 * @param val the value
 */
// tslint:disable-next-line:no-any
export const isInEnum: (enumType: any, val: any) => boolean = (enumType, val) =>
	Object.values(enumType).includes(val);

/**
 * Casts a value to an Enum value if the Enum type contains the value. Otherwise returns a
 * default value or null
 * @param enumType the Enum type
 * @param val the value to be casted
 * @param defaultVal a fallback value
 */
// tslint:disable-next-line:no-any
export function toEnum<T>(enumType: any, val: T, defaultVal?: T): T | null {
	if (isInEnum(enumType, val)) {
		return val;
	}
	return defaultVal || null;
}

export const toEnumKey = <T>(enumType: any, val: T, defaultVal?: T): T | null =>{
	for (const [key, value] of Object.entries(enumType))
		if(value === val)
			return key as unknown as T;

	return defaultVal || null;
}
